export default __webpack_public_path__ + "static/media/receiveToken.57055eed.png";